import { IAtIconProps } from './at-icon.types';
import { EIcons } from './icons';

export const atIconMockData: IAtIconProps = {
  icon: EIcons.DOWNLOAD,
  color: '#000',
};
